import { useWebsiteSettings } from 'publisher/store'
import { getWebsiteStylesTypographyHeading } from 'src/publisher/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useCalculateHeadingLetterSpacing = ({
  letterSpacing,
  mobileLetterSpacing,
}: {
  letterSpacing?: number
  mobileLetterSpacing?: number
}) => {
  const {
    letterSpacing: globalLetterSpacing,
    mobileLetterSpacing: globalMobileLetterSpacing,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  return {
    calculatedLetterSpacing: getCalculatedProperty({
      desktopProperty: letterSpacing,
      mobileProperty: mobileLetterSpacing,
      globalDesktopProperty: globalLetterSpacing,
      globalMobileProperty: globalMobileLetterSpacing,
    }),
    globalLetterSpacing,
    globalMobileLetterSpacing,
  }
}
